<template>
  <div>
    <el-table :data="switchList">
      <el-table-column prop="coinType" label="币种"></el-table-column>
      <el-table-column label="提现总开关">
        <template slot-scope="scope">
          <el-switch
            :value="scope.row.allPassWithdraw"
            @change="
              handleSwitchChange(scope.row.coinType, 'allPassWithdraw', $event)
            "
            active-color="#13ce66"
          ></el-switch>
        </template>
      </el-table-column>
      <el-table-column label="提现单批次开关">
        <template slot-scope="scope">
          <el-switch
            :value="scope.row.oneBatchWithdraw"
            @change="
              handleSwitchChange(scope.row.coinType, 'oneBatchWithdraw', $event)
            "
            active-color="#13ce66"
          ></el-switch>
        </template>
      </el-table-column>
      <el-table-column label="转账中开关">
        <template slot-scope="scope">
          <el-switch
            :value="scope.row.transferInProgress"
            @change="
              handleSwitchChange(
                scope.row.coinType,
                'transferInProgress',
                $event
              )
            "
            active-color="#13ce66"
          ></el-switch>
        </template>
      </el-table-column>
      <el-table-column label="转冷单次开关"
        ><template slot-scope="scope">
          <el-switch
            :value="scope.row.toColdOneTimeSwitch"
            @change="
              handleSwitchChange(
                scope.row.coinType,
                'toColdOneTimeSwitch',
                $event
              )
            "
            active-color="#13ce66"
          ></el-switch>
        </template>
      </el-table-column>
      <el-table-column label="提现批次Size">
        <template slot-scope="scope">
          <a @click="handleBatchWithdrawSizeChange(scope.row.coinType)">
            {{ scope.row.batchWithdrawSize }}<i class="el-icon-edit"></i>
          </a>
        </template>
      </el-table-column>
      <el-table-column label="提现Gas Price">
        <template slot-scope="scope">
          <a
            @click="handleGasPriceChange(scope.row.coinType)"
            v-if="scope.row.supportSettingWithdrawGasPriceInGwei"
          >
            {{ scope.row.withdrawGasPriceInGwei }}<i class="el-icon-edit"></i>
          </a>
        </template>
      </el-table-column>
      <el-table-column label="转冷Gas Price">
        <template slot-scope="scope">
          <a
            @click="handleToColdGasPriceChange(scope.row.coinType)"
            v-if="scope.row.supportSettingToColdGasPriceInGwei"
          >
            {{ scope.row.toColdGasPriceInGwei }}<i class="el-icon-edit"></i>
          </a>
        </template>
      </el-table-column>

      <el-table-column label="提现gasLimit">
        <template slot-scope="scope">
          <a
            @click="handleGasLimitChange(scope.row.coinType)"
            v-if="scope.row.withdrawGasLimit"
          >
            {{ scope.row.withdrawGasLimit }}<i class="el-icon-edit"></i>
          </a>
        </template>
      </el-table-column>

      <el-table-column label="转冷gasLimit">
        <template slot-scope="scope">
          <a
            @click="handleToColdGasLimitChange(scope.row.coinType)"
            v-if="scope.row.toColdGasLimit"
          >
            {{ scope.row.toColdGasLimit }}<i class="el-icon-edit"></i>
          </a>
        </template>
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button
            type="primary"
            icon="el-icon-refresh"
            circle
            @click="refreshRow(scope.row.coinType, scope.$index)"
          ></el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog
      title="提示"
      :visible.sync="dialogVisible"
      width="30%"
      :before-close="handleClose"
    >
      <span>这是一段信息</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible = false"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';

export default {
  name: 'SwitchList',
  computed: {
    ...mapState('walletSwitchSetting', ['switchList'])
  },
  methods: {
    ...mapActions('walletSwitchSetting', [
      'list',
      'updateSwitchStatus',
      'updateBatchWithdrawSize',
      'updateGasPrice',
      'updateToColdGasPrice',
      'getSwitchConfigInfoByCoinType',
      'updateGasLimitChange',
      'updateToColdGasLimitChange'
    ]),
    handleSwitchChange(coinType, switchType, status) {
      this.$confirm('确认进行此操作吗？', '提示', { type: 'warning' }).then(
        () => {
          this.updateSwitchStatus({ coinType, switchType, status }).then(() => {
            this.$message.success('操作成功！');
            this.list();
          });
        }
      );
    },
    handleBatchWithdrawSizeChange(coinType) {
      this.$prompt('请输入size', '提示', {
        inputValidator: value => {
          return !value || !value.trim() ? '请输入size' : true;
        }
      }).then(({ value }) => {
        this.updateBatchWithdrawSize({ coinType, size: Number(value) }).then(
          () => {
            this.$message.success('操作成功！');
            this.list();
          }
        );
      });
    },
    handleGasPriceChange(coinType) {
      this.$prompt('请输入gas price', '提示').then(({ value }) => {
        this.updateGasPrice({
          coinType,
          price:
            typeof value === 'undefined' || typeof value === 'object'
              ? undefined
              : Number(value)
        }).then(() => {
          this.$message.success('操作成功！');
          this.list();
        });
      });
    },
    handleToColdGasPriceChange(coinType) {
      this.$prompt('请输入gas price', '提示').then(({ value }) => {
        this.updateToColdGasPrice({
          coinType,
          price:
            typeof value === 'undefined' || typeof value === 'object'
              ? undefined
              : Number(value)
        }).then(() => {
          this.$message.success('操作成功！');
          this.list();
        });
      });
    },
    handleGasLimitChange(coinType) {
      this.$prompt('请输入gasLimit', '提示').then(({ value }) => {
        this.updateGasLimitChange({
          coinType,
          gasLimit:
            typeof value === 'undefined' || typeof value === 'object'
              ? undefined
              : Number(value)
        }).then(() => {
          this.$message.success('操作成功！');
          this.list();
        });
      });
    },

    handleToColdGasLimitChange(coinType) {
      this.$prompt('请输入gasLimit', '提示').then(({ value }) => {
        this.updateToColdGasLimitChange({
          coinType,
          gasLimit:
            typeof value === 'undefined' || typeof value === 'object'
              ? undefined
              : Number(value)
        }).then(() => {
          this.$message.success('操作成功！');
          this.list();
        });
      });
    },
    /** 刷新单行数据*/
    refreshRow(coinType, index) {
      this.getSwitchConfigInfoByCoinType(coinType).then(response => {
        this.$set(this.switchList, index, response.data);
        // this.list();
      });
    }
  },
  created() {
    this.list();
  }
};
</script>

<style lang="less" scoped></style>
